import React, { useEffect } from "react";
import Metatag from "../../components/Metatag/Metatag";

const Modifications = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Metatag
        title="Electrical & Network Modifications | DEWA Approvals"
        description="Require electricity or water network modifications? Megavolt is a trusted DEWA approved contractor offering modification services across Dubai, UAE."
        link="modifications"
      />
      <div>
        <div className="text-center items-center mb-10 mt-10">
          <h1 className="text-[34px] font-semibold text-[black]">
            Electrical & Network <span className="text-[#ffb732] text-[38px]">Modifications</span>
          </h1>
          <p className="mt-3 text-lg font-medium text-gray-700 px-4">
            Authorized DEWA Network Modifications & Approvals
          </p>
        </div>

        <div className="flex-col flex lg:flex-row gap-[19px] sm:gap-10 lg:justify-around sm:w-[85%] sm:mx-auto p-4 mb-20 relative">
          <div className="rounded-xl w-full border-t-[2px] border-[#cbcbcb] lg:p-10 p-5 bg-white" style={{ boxShadow: '0px 2px 25px #7c78754f' }}>
            <p className="text-[#090a0e] text-lg leading-loose mb-6 text-justify">
              Whether you are rearranging an office, expanding a warehouse, or redesigning a residential villa, you need a certified <strong>DEWA approved contractor</strong> to handle your electricity and water network modifications. At <strong>Megavolt Technical Services Co. LLC</strong>, we ensure your internal infrastructure fits your evolving structural needs without compromising safety or regulatory standards.
            </p>
            <p className="text-[#090a0e] text-lg leading-loose mb-8 text-justify">
              Any alteration to a pre-existing Electrical and Water network requires stringent <strong>DEWA approvals</strong>. We streamline this process to guarantee minimal downtime to your facility operations, utilizing over 7 years of deep market expertise in Dubai.
            </p>

            <h2 className="text-[#ffb732] text-3xl font-semibold mb-4 border-b-2 border-[#ffb732] inline-block pb-2">Our Modification Services</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
              <div className="bg-gray-100 p-6 rounded-lg border border-gray-200 shadow-sm">
                <h3 className="font-bold text-xl mb-3 text-black">Electricity Network Modification</h3>
                <p className="text-gray-700">From relocating DBs (Distribution Boards) to altering final circuit wiring in commercial fit-outs, we manage every electrical alteration alongside formal <strong>DEWA approval</strong> applications.</p>
              </div>
              <div className="bg-gray-100 p-6 rounded-lg border border-gray-200 shadow-sm">
                <h3 className="font-bold text-xl mb-3 text-black">Water Network Modification</h3>
                <p className="text-gray-700">Rerouting water supply lines or adjusting water layouts, or upgrading water network for industial purpose. Handled with absolute precision by our Water layout specialists.</p>
              </div>
            </div>

            <div className="bg-gray-50 border border-[#cbcbcb] p-8 rounded-lg mb-10">
              <h3 className="font-bold text-2xl mb-4 text-[#ffb732]">Why Modifications Require DEWA Approvals</h3>
              <p className="mb-4 text-lg text-[#090a0e]">
                Unapproved electrical modifications can lead to severe safety hazards and hefty fines in Dubai. As your primary <strong>DEWA approved contractor</strong>, we submit revised Load Schedules, Single Line Diagrams (SLDs), and layout drawings on your behalf. We ensure your modifications achieve the fastest <strong>DEWA approvals</strong> on the market.
              </p>
            </div>

            <div className="text-center bg-[#f9f9f9] border border-gray-300 p-8 rounded-lg shadow-inner">
              <h2 className="text-[#ffb732] text-3xl font-bold mb-4">Need to Modify Your Connections?</h2>
              <p className="text-[#090a0e] text-lg leading-loose mb-4">
                Let the experts at Megavolt Technical Services assist you with seamless installations and rapid <strong>DEWA approval</strong> turnarounds.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modifications;
